import React, { useState, useEffect, useRef } from 'react';
import  { CloudUpload, SkipPrevious, PlayArrow, SkipNext, Stop } from '@material-ui/icons';
import { Button , makeStyles, useTheme, Card, CardContent, IconButton, Typography } from '@material-ui/core';
import * as Tone from 'tone';

import shortid from 'short-id';
import sine220 from "../Musics/sine220.mp3";
import sine330 from "../Musics/sine330.mp3";
import sine440 from "../Musics/sine440.mp3" ;
import triphop60 from "../Musics/triphop_60bpm.mp3" ;
import hiphop90 from "../Musics/hiphop_90bpm.mp3" ;


let sounds_local = [
    {
        name:"sine 220HZ",
        file: sine220,
    },
    {
        name:"sine 330HZ",
        file: sine330,
    },
    {
        name:"sine 440HZ",
        file: sine440,
    },
    {
        name:"drum triphop 60bpm",
        file: triphop60,
    },
    {
        name:"drum hiphop 90bpm",
        file: hiphop90,
    },
];

//const tonePlayerLeft = new Tone.Player(sounds_local[0].file);
//tonePlayerLeft.loop = true;

//const tonePlayerRight = new Tone.Player(sounds_local[0].file);
//tonePlayerRight.loop = true;

let highpass = new Tone.Filter(2000, "highpass").toDestination();
let lowpass = new Tone.Filter(2000, "lowpass").toDestination();
let vibrato = new Tone.Vibrato(10, 0.1).toDestination();
let distortion = new Tone.Distortion(0.1).toDestination();
let feedback = new Tone.FeedbackDelay(0.5, 0.2).toDestination();
let phaser = new Tone.Phaser(400, 4, 1000).toDestination();
let chorus = new Tone.Chorus(800, 200, 0.5).toDestination();

const useStyles = makeStyles((theme) => ({
    input: {
        display: 'none',
    },
    btn: {
        margin : 5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    root: {
        display: 'flex',
        justifyContent: "center",
        width: 500,
        alignSelf: "center",
        margin: 5 ,
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        flex: '1 0 auto',
        flexDirection: 'column',
        alignItems: 'center'
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    stopIcon: {
        height: 38,
        width: 38,
    },
    main: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }
}));

function Sound({filters, muse, _id}) {

    //Tone.Player(sounds_local[0].file) ;
    const tonePlayerLeft = new Tone.Player(sounds_local[0].file);
    tonePlayerLeft.loop = true;
    const tonePlayerRight = new Tone.Player(sounds_local[0].file);
    tonePlayerRight.loop = true;


    const playerRef = useRef(_id === 0 ? tonePlayerLeft : tonePlayerRight);
    const [soundIndex, setSoundIndex] = useState(0);
    const [newFilters, setNewFilters] = useState([]);
    const [currentFilters, setCurrentFilters] = useState([]);
    const player = useRef(_id === 0 ? tonePlayerLeft : tonePlayerRight);
    const classes = useStyles();
    const theme = useTheme();
    let mySound =  undefined;
    let soundToPlay = undefined;
    const[nameOfSound, setNameOfSound] = useState(sounds_local[0].name);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isUpload, setUpload] = useState(false);
    const [filtersInterval, setFiltersInterval] = useState(undefined);
    const [highpassOn, setHighpassOn] = useState(false);
    const [lowpassOn, setLowpassOn] = useState(false);
    const [vibratoOn, setVibratoOn] = useState(false);
    const [distortionOn, setDistortionOn] = useState(false);
    const [feedbackOn, setFeedbackOn] = useState(false);
    const [phaserOn, setPhaserOn] = useState(false);
    const [chorusOn, setChorusOn] = useState(false);

    useEffect(async() => {
        playerRef.current.load(sounds_local[soundIndex].file);
        setNameOfSound(sounds_local[soundIndex].name);
    }, [soundIndex])

    useEffect(async() => {
        playerRef.current.disconnect();
        playerRef.current.chain(...newFilters, Tone.Destination);

        if(isUpload){
            player.current.disconnect();
            player.current.chain(...newFilters, Tone.Destination);
        }
        setCurrentFilters([...newFilters]);
    }, [newFilters])
    
    useEffect(async () => {
        if(filters['Highpass'] !== 'None')
        {
            if(!highpassOn) {
                setHighpassOn(true);
                setNewFilters([...currentFilters, highpass]);
            }
        }else{
            if(highpassOn) {
                setHighpassOn(false);
                let array = [...currentFilters];
                array.splice(array.indexOf(highpass), 1);
                setNewFilters([...array]);
            }
        }

        if(filters['Lowpass'] !== 'None')
        {
            if(!lowpassOn) {
                setLowpassOn(true);
                setNewFilters([...currentFilters, lowpass]);
            }
        }else{
            if(lowpassOn) {
                setLowpassOn(false);
                let array = [...currentFilters];
                array.splice(array.indexOf(lowpass), 1);
                setNewFilters([...array]);
            }
        }

        if(filters['Vibrato'] !== 'None')
        {
            if(!vibratoOn) {
                setVibratoOn(true);
                setNewFilters([...currentFilters, vibrato]);
            }
        }else{
            if(vibratoOn) {
                setVibratoOn(false);
                let array = [...currentFilters];
                array.splice(array.indexOf(vibrato), 1);
                setNewFilters([...array]);
            }
        }

        if(filters['Distortion'] !== 'None')
        {
            if(!distortionOn) {
                setDistortionOn(true);
                setNewFilters([...currentFilters, distortion]);
            }
        }else{
            if(distortionOn) {
                setDistortionOn(false);
                let array = [...currentFilters];
                array.splice(array.indexOf(distortion), 1);
                setNewFilters([...array]);
            }
        }

        if(filters['Feedback delay'] !== 'None')
        {
            if(!feedbackOn) {
                setFeedbackOn(true);
                setNewFilters([...currentFilters, feedback]);
            }
        }else{
            if(feedbackOn) {
                setFeedbackOn(false);
                let array = [...currentFilters];
                array.splice(array.indexOf(feedback), 1);
                setNewFilters([...array]);
            }
        }

        if(filters['Phaser'] !== 'None')
        {
            if(!phaserOn) {
                setPhaserOn(true);
                setNewFilters([...currentFilters, phaser]);
            }
        }else{
            if(phaserOn) {
                setPhaserOn(false);
                let array = [...currentFilters];
                array.splice(array.indexOf(phaser), 1);
                setNewFilters([...array]);
            }
        }

        if(filters['Chorus'] !== 'None')
        {
            if(!chorusOn) {
                setChorusOn(true);
                setNewFilters([...currentFilters, chorus]);
            }
        }else{
            if(chorusOn) {
                setChorusOn(false);
                let array = [...currentFilters];
                array.splice(array.indexOf(chorus), 1);
                setNewFilters([...array]);
            }
        }

        if(isPlaying)
        {
            await setFiltersInterval(clearInterval(filtersInterval));
            setFiltersInterval(setInterval(handleFilters, 1000));
        }
    }, [filters])

    function handleClick() {
        if(!isPlaying)
        {
            if(!isUpload && player.current.loaded){
                //Son local
                playerRef.current.start();
            }
            if(player.current != undefined && isUpload){
              player.current.start();
            }
            setIsPlaying(true);
            setFiltersInterval(setInterval(handleFilters, 1000));
        }else{
            playerRef.current.stop();
            setIsPlaying(false);
            if(player.current != undefined){
              player.current.stop();
            }
            setFiltersInterval(clearInterval(filtersInterval));
        }
    }

    function handleRefactor() {
        highpass = new Tone.Filter(2000, "highpass").toDestination();
        lowpass = new Tone.Filter(2000, "lowpass").toDestination();
        vibrato = new Tone.Vibrato(10, 0.1).toDestination();
        distortion = new Tone.Distortion(0.1).toDestination();
        feedback = new Tone.FeedbackDelay(0.5, 0.2).toDestination();
        phaser = new Tone.Phaser(400, 4, 1000).toDestination();
        chorus = new Tone.Chorus(800, 200, 0.5).toDestination();
    }

    function handleFilters() {
        highpass.set({ frequency: (getValue(filters['Highpass']) * (5000 - 0) + 0) });
        lowpass.set({ frequency: (getValue(filters['Lowpass']) * (2500 - 300) + 300) });
        vibrato.set({ frequency: (getValue(filters['Vibrato']) * (30 - 0) + 0) });
        distortion.set({ distortion: (getValue(filters['Distortion']) * (0.4 - 0) + 0) });
        feedback.set({ feedback: (getValue(filters['Feedback delay']) * (0.8 - 0.4) + 0.4) });
        phaser.set({ frequency: (getValue(filters['Phaser']) * (750 - 0) + 0) });
        chorus.set({ frequency: (getValue(filters['Chorus']) * (600 - 0) + 0) });
    }

    function getValue(value) {
        switch(value) {
            case 'Alpha':
                return muse.getAlpha();
            case 'Beta':
                return muse.getBeta();
            case 'Delta':
                return muse.getDelta();
            case 'Gamma':
                return muse.getGamma();
            case 'Theta':
                return muse.getTheta();
            case 'Alpha/Delta' :
                return muse.getRatioAlphaOfDelta() ;
            case 'Theta/Beta' :
                return muse.getRatioThetaOfBeta() ;    
            case 'None':
                return 0;
        }
    }

    function handlerFile(event){
        if(isUpload == false){
            setUpload(true);
        }
        mySound = event.target.files[0];
        if(mySound != undefined){
            setNameOfSound(event.target.files[0].name);
            soundToPlay = URL.createObjectURL(mySound);
        }
        player.current = new Tone.Player(soundToPlay).toDestination();
        console.log(player);
    }

    const toPrevTrack = () => {
        playerRef.current.stop();

        if (soundIndex === 0) {
            setSoundIndex(sounds_local.length - 1);
        } else {
            setSoundIndex(soundIndex - 1);
        }
    };

    const toNextTrack = () => {
        playerRef.current.stop();

        if (soundIndex < sounds_local.length - 1) {
            setSoundIndex(soundIndex + 1);
        } else {
            setSoundIndex(0);
        }
    };
    let id = shortid.generate();

    return(
        <div className={classes.main}>
            <div>
                <Card className={classes.root}>
                    <div className={classes.details}>
                        <CardContent className={classes.content}>
                            <Typography component="h5" variant="h5">
                                {nameOfSound}
                            </Typography>
                        </CardContent>
                        <div className={classes.controls}>
                            <IconButton aria-label="previous" onClick={toPrevTrack}>
                                {theme.direction === 'rtl' ? <SkipNext /> : <SkipPrevious />}
                            </IconButton>
                            <IconButton aria-label="play/pause" onClick={handleClick}>{isPlaying ? <Stop className={classes.playIcon} /> : <PlayArrow className={classes.stopIcon}/>}</IconButton>
                            <IconButton aria-label="next" onClick={toNextTrack}>
                                {theme.direction === 'rtl' ? <SkipPrevious /> : <SkipNext />}
                            </IconButton>
                        </div>
                    </div>
                </Card>
            </div>
            <input
                accept="audio/*"
                id={id}
                className={classes.input}
                multiple
                type="file"
                onChange={handlerFile}
            />
            <label htmlFor={id}>
                <Button variant="contained" color="primary" component="span" className={classes.btn} startIcon={<CloudUpload />}>
                    {isUpload ? "Uploaded" : "Upload"}
                </Button>
            </label>
            <Button variant="outlined" color="primary" onClick={handleRefactor}>Restart</Button>
        </div>
    )

}

export default Sound;
